import { NgModule }         from '@angular/core';
import { CommonModule }     from '@angular/common';
import { RouterModule }     from '@angular/router';
import { FormsModule }      from '@angular/forms';
import { MatSelectModule }  from '@angular/material/select';
import { NgbModule }        from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule }  from '@ngx-translate/core';

import { HeaderComponent }      from '@core/header/header.component';
import { NavigationComponent }  from '@core/navigation/navigation.component';
import { FooterComponent }      from '@core/footer/footer.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    TranslateModule.forRoot(),
    MatSelectModule
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    NavigationComponent
  ],
  providers: [],
  exports: [
    HeaderComponent,
    FooterComponent,
    NavigationComponent
  ]
})
export class CoreModule {
}
